import React from 'react'

/** Premium card with consistent padding and dark glass style. */
export default function Card({ children, className = '', padding = 'default', ...rest }) {
  const paddingClass = padding === 'none' ? 'p-0' : padding === 'tight' ? 'p-4' : 'p-6'
  return (
    <div
      className={`rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-lg transition-shadow hover:border-white/15 ${paddingClass} ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}
